import request from '@/utils/request'

// 跳转到第三方登录页面
export function render(source) {
  return request({
    url: '/oauth/render/' + source,
    method: 'get',
  })
}
